<template>
  <div class="container-fluid">
    <div class="card bg-light-info shadow-none position-relative overflow-hidden">
      <div class="card-body px-4 py-3">
        <div class="row align-items-center">
          <div class="col-9">
            <h4 class="fw-semibold mb-8">Configuración de sistema</h4>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link class="text-muted" :to="{ name: 'Calendar' }">Inicio</router-link>
                </li>
                <li class="breadcrumb-item" aria-current="page">
                  Configuración de sistema
                </li>
              </ol>
            </nav>
          </div>
          <div class="col-3">
            <div class="text-center mb-n5">
              <img src="@/assets/images/breadcrumb/ChatBc.png" alt="" class="img-fluid mb-n4">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row gx-0">
      <div class="col-12">
        <app-settings/>
      </div>
      <div class="col-lg-6">
        <mail-settings/>
      </div>
      <div class="col-lg-6">
        <mail-test/>
      </div>
    </div>
  </div>
</template>
<script>
import AppSettings from './App'
import MailSettings from './Mail'
import MailTest from './MailTest'
export default {
  components: { AppSettings, MailSettings, MailTest }
}
</script>



// WEBPACK FOOTER //
// src/pages/config/Config.vue